import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryQuestionAnsweringState extends ConditionRegistryCategory {
    label = 'Beantwortung (Status)';
    constructor(parent) {
        super(parent);
        super.init();
    }
    gf345345v = () => new ConditionRegistryItem({
        /* label: 'Frage soll sichtbar sein / ist sichtbar', */
        eval: ({ app, question }) => {
            if (app.appInfo.isUserCurrentlyEditing)
                return true;
            if (!question)
                return false;
            return question.questionAppear.shouldBeVisible;
        },
    });
    fdgd435435 = () => new ConditionRegistryItem({
        /* label: 'Frage wird derzeit beantwortet', */
        eval: ({ question }) => !!question && question.answeringState.isInAnsweringState,
    });
    rJ8ljZwg = () => new ConditionRegistryItem({
        /*  label: 'Frage fertig beantwortet', */
        eval: ({ question }) => !!question && question.answeringState.isCompletlyAnswered,
    });
    rJ8ljZwh = () => new ConditionRegistryItem({
        /*  label: 'Frage fertig beantwortet oder Editing', */
        eval: ({ app, question }) => (!!question && question.answeringState.isCompletlyAnswered) || app.appInfo.isUserCurrentlyEditing,
    });
    AfgJ8jhj = () => new ConditionRegistryItem({
        /* label: 'Beantwortung der Frage abgeschlossen', */
        eval: ({ question }) => !!question && question.answeringState.isAnswerFinished,
    });
    tre4j35 = () => new ConditionRegistryItem({
        /*  label: 'Frage erhält derzeit Feedback', */
        eval: ({ question }) => !!question && question.answeringState.isInFeedbackState,
    });
    HkVfoWDW = () => new ConditionRegistryItem({
        /* label: 'Frage korrekt beantwortet', */
        eval: ({ question }) => !!question && question.answeringState.wasAnsweredFullyCorrect,
    });
    BkcMivbe = () => new ConditionRegistryItem({
        /*   label: 'Frage falsch beantwortet', */
        eval: ({ question }) => !!question && question.answeringState.wasAnsweredWrong,
    });
    Bkc556e = () => new ConditionRegistryItem({
        /*  label: 'Frage teilweise falsch beantwortet', */
        eval: ({ question }) => !!question && question.answeringState.wasAnsweredPartiallyWrong,
    });
    Sk7miZwW = () => new ConditionRegistryItem({
        /*   label: 'Frage komplett falsch beantwortet', */
        eval: ({ question }) => !!question && question.answeringState.wasAnsweredCompletlyWrong,
    });
    Rkh5A = () => new ConditionRegistryItem({
        /*   label: 'Fragestellung vorgelesen', */
        eval: ({ app }) => app.asking.askingMedia.hatFragestellungVorgelesen,
    });
    Rkh5B = () => new ConditionRegistryItem({
        /*   label: 'Audio / Video Rückmeldung ist fertig', */
        eval: ({ app }) => app.asking.askingProgress.hatRueckmeldungErhalten,
    });
    Sk7XW = () => new ConditionRegistryItem({
        /*   label: 'Hatte Fehler in vergangenen 1500ms', */
        eval: ({ question }) => !!question && question.answeringStepMistake.showMistakeFeedback_1500ms,
    });
    g5Ft = () => new ConditionRegistryItem({
        label: 'Trigger Enforcment Tip',
        eval: ({ app }) => app.pose.poseEnforce.shouldTriggerEnforcementTip,
    });
    g98t = () => new ConditionRegistryItem({
        label: 'Trigger Enforcment Push',
        eval: ({ app }) => app.pose.poseEnforce.shouldTriggerEnforcementPush,
    });
}
